import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../ModalContainer/ModelContainer'
import { VistorModalTypes, getVisitorTypeModalConfig, getVisitorFormModalType } from '.././utils'
import ModalButtons from '../ModalButtons'

const VisitorTypeModal = ({
  isOpen,
  visitorModalType,
  toggleNewVisitorModalType,
  editingVisitor,
}) => {
  const { t } = useTranslation(['visitors'])
  const [selectedVisitorType, setSelectedVisitorType] = useState(null)
  const [isSelected, setIsSelected] = useState(false)
  const isEditMode = !!editingVisitor?.id

  const modalConfig = getVisitorTypeModalConfig(t, visitorModalType)
  const isGuestOrVendorTypeModal = [
    VistorModalTypes.GuestTypeModal,
    VistorModalTypes.VendorTypeModal,
  ].includes(visitorModalType)

  useEffect(() => {
    if (!isOpen) {
      return
    }

    if (isEditMode && visitorModalType === VistorModalTypes.GuestTypeModal) {
      const currentVisitorType = getVisitorFormModalType(editingVisitor)
      setSelectedVisitorType(currentVisitorType)
      setIsSelected(true)
      return
    }

    setSelectedVisitorType(null)
    setIsSelected(false)
  }, [editingVisitor, isEditMode, isOpen, visitorModalType])

  const handleModalButtonClick = (modalType) => {
    toggleNewVisitorModalType(modalType)
    setIsSelected(false)
  }

  if (!modalConfig || !isOpen) {
    return null
  }

  return (
    <ModalContainer
      onClose={() => toggleNewVisitorModalType()}
      additionalClass="visitor-modal"
      headerTitle={modalConfig.header}
    >
      <div className="visitor-modal__body">
        <p className="visitor-modal__subheader">{modalConfig.subHeader}</p>
        <div className="visitor-modal__types-container">
          {modalConfig.options.map((option) => {
            return (
              <div
                key={option.value}
                className={`visitor-modal__type ${
                  selectedVisitorType === option.value ? 'visitor-modal__type--selected' : ''
                }`}
                onClick={() => {
                  setSelectedVisitorType(option.value)
                  setIsSelected(true)
                }}
              >
                {option.icon}
                <div className="visitor-modal__type-name">{option.text}</div>
              </div>
            )
          })}
        </div>
        <ModalButtons
          primaryButtonText={
            isEditMode ? t('visitors:modalTypes.next') : t('visitors:modalTypes.create')
          }
          onPrimaryButtonClick={() => handleModalButtonClick(selectedVisitorType)}
          primaryButtonDisabled={!isSelected}
          secondaryButtonText={
            isGuestOrVendorTypeModal && !isEditMode
              ? t('visitors:form.back')
              : t('visitors:modalTypes.cancel')
          }
          onSecondaryButtonClick={() =>
            handleModalButtonClick(
              isGuestOrVendorTypeModal && !isEditMode
                ? VistorModalTypes.VisitorTypeModal
                : undefined,
            )
          }
        />
      </div>
    </ModalContainer>
  )
}

VisitorTypeModal.propTypes = {
  isOpen: PropTypes.bool,
  visitorModalType: PropTypes.string,
  toggleNewVisitorModalType: PropTypes.func.isRequired,
  editingVisitor: PropTypes.object,
}

export default VisitorTypeModal
